/** The application's name, and the page's only level one heading. Its own
 *  module, so the screen a broken deployment shows does not have to import
 *  the whole application to spell it. */
export const APP_NAME = "Transport planner";
